import React from "react";
import "./Contact.css";
export default function Contact() {
  return (
    <div className="contact_parent containers">
        <div className="home_page my-2">
            <h3>Home <i class="bi bi-chevron-right"></i> </h3>
            <p>Contact</p>
        </div>
      <section className="contact">
        <div className="container-contact">
          <h1 className="contact-title">Contacts</h1>
          <p className="contact-info mt-3">
            Do you have suggestions or criticisms about the activities of the
            site? «Tahlil24.uz» do you want to send an article or message to? Or
            do you want to inform yourself about some kind of event that you
            witnessed? Ready for cooperation, please contact us.
          </p>
          <h1 className="contact-title my-3">Sending a message</h1>
          <form action="/" className="my-3">
            <div className="registration">
              <div className="input-wraper">
                <input className="form_inputs" type="name contact-input" placeholder="Name" />
                <ion-icon name="person-outline" id="input-icon"></ion-icon>
              </div>
              <div className="input-wraper" placeholder="email">
                <ion-icon name="mail-outline" id="input-icon"></ion-icon>
                <input className="form_inputs" type="email contact-input" placeholder="Email" />
              </div>
              <div className="input-wraper">
                <input className="form_inputs"
                  type="phone contact-input"
                  placeholder=" Tel +998999998877"
                />
                <ion-icon name="call-outline" id="input-icon"></ion-icon>
              </div>
            </div>
            <h1 className="contact-title my-4 mesage-title">
              Message content
            </h1>
            <div className=" mb-3">
              <textarea name="" id="" rows="7" className="p-2 textarea"></textarea>
            </div>
            <div className="send-value mt-30">
              <button type="submit" className="primary-btn">
                Send Message
              </button>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
}
